import { createColumnHelper, CellContext } from "@tanstack/react-table";
import React, { useState } from "react";
import UserPicker from "../../../controls/UserPicker";
import Loading from "../../../cross/Loading";
import { EnumEstadoAuditoria } from "../../../entities/helper/EnumEstadoAuditoria";
import ICurrentUser from "../../../entities/helper/ICurrentUser";
import IUserPickerValue from "../../../entities/helper/IUserPickerValue";
import IAuditoria from "../../../entities/IAuditoria";
import { IItemNormativaxAuditoria } from "../../../entities/IItemNormativaxAuditoria";
import IItemNormativo from "../../../entities/IItemNormativo";
import { ITipoAlcance } from "../../../entities/ITipoAlcance";
import { ITipoUnidadAuditar } from "../../../entities/ITipoUnidadAuditar";
import { shortDate } from "../../../helpers/dateHelper";
import { ITipo_Campo } from "../../../helpers/IFormHelper";
import { deleteAPI, getAPI, postAPI } from "../../../helpers/httpHelper";
import { usePromiseEffect } from "../../../helpers/promiseEffect";
import { cognitoUserInfo, cognitoUserToken } from "../../../helpers/userHelper";
import {
  API_ADMIN_TIPO_ALCANCE,
  API_ADMIN_TIPO_UNIDAD_AUDITAR,
  API_AUDITORIA,
  API_AUDITORIA_DELETE_ITEMNORMATIVO,
  API_AUDITORIA_GET_AUDITORIA,
  API_AUDITORIA_GET_ITEMNORMATIVA_AUDITORIA,
  API_AUDITORIA_GET_TIPOALCANCE_AUDITORIA,
  API_AUDITORIA_POST_AUDITORIA,
  API_AUDITORIA_POST_AUDITORIA_APROBARAUDITORIA,
  ROW_COUNT,
  ROW_COUNT_MAX,
  URL_SUPPORT,
} from "../../../helpers/variableHelper";
import AdminLista from "../../administration/AdminLista";
import FormItemNormativa from "./FormItemNormativa";
import Swal, { SweetAlertResult } from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import AuditoriaService from "../../../services/AuditoriaService";
import IItemNormativoActive from "../../../entities/IItemNormativoActive";
import RenderTitle from "../../../controls/RenderTitle";
import RenderValue from "../../../controls/RenderValue";
const MySwal = withReactContent(Swal);

interface IDetallePlanAuditoriaProps {
  readonly?: boolean;
  loading?: boolean;
  items?: Array<ITipoAlcance>;
  is_test?: boolean;
}
export default function DetallePlanAuditoria({ readonly, loading = true, items, is_test }: IDetallePlanAuditoriaProps) {
  // NOSONAR Dejamos justificado que estas validaciones corresponden a validacion de propiedades en la carga del detalle de plan de auditoría
  let search = new URLSearchParams(window.location.search);
  const idAuditoria = parseInt(search.get("id") || "0");
  const isHistorico = isNaN(parseInt(search.get("isHistorico") || "")) ? false : true;
  if (isHistorico) {
    readonly = true;
  }
  const userInfo = cognitoUserToken();
  const esVistaPlan = window.location.href.includes("/plan?");
  const [token, setToken] = useState("");
  const [isLoading, setIsLoading] = useState(loading);
  const [isSendingData, setIsSendingData] = useState(false);
  const [currentUser, setCurrentUser] = useState<ICurrentUser>();
  const [pages, setPages] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(ROW_COUNT);
  const [isEdit, setIsEdit] = useState(readonly != undefined ? !readonly : false);
  const [auditoriaSeleccionada, setAuditoriaSeleccionada] = useState<IAuditoria>();

  const [tipoAlcanceAuditoria, setTipoAlcanceAuditoria] = useState<Array<ITipoAlcance>>([]);
  const [allTipoAlcanceAuditoria, setAllTipoAlcanceAuditoria] = useState<Array<ITipoAlcance>>([]);
  const [itemNormativaAuditoria, setItemNormativaAuditoria] = useState<Array<ITipoAlcance> | null>(items || null);
  const [listUnidadesAuditar, setListUnidadesAuditar] = useState<Array<ITipoUnidadAuditar>>([]);
  const [arrErrorEmpty, setArrErrorEmpty] = useState<Array<string>>([]);
  const [isOpenModalItemNormativo, setIsOpenModalItemNormativo] = useState(false);
  const [selectedItemNormativo, setSelectedItemNormativo] = useState<IItemNormativo | null>(null);

  const [selectedItemNormativoList, setSelectedItemNormativoList] = useState<IItemNormativoActive | null>(null);

  const [valResponsableArea, setValResponsableArea] = useState<IUserPickerValue | null>(null);
  const [valAuditoresParticipantes, setValAuditoresParticipantes] = useState<IUserPickerValue[] | null>(null);
  const component = (titulo: string) => {
    return <RenderTitle title={titulo} />;
  };

  const componentValue = (value: any) => {
    return <RenderValue value={value} />;
  };

  const componentOpciones = (value: any) => {
    return (
      <div>
        <i
          className="bi bi-search iconSearch me-2 text-decoration-none"
          onClick={() => {
            setIsOpenModalItemNormativo(true);
            setSelectedItemNormativo(value.row.original);
            setSelectedItemNormativoList({ REQUISITOS_NORMATIVOS: getRequisitos(itemNormativaAuditoria) as any });
          }}></i>
        <i
          className="bi bi-trash iconTrash text-decoration-none"
          onClick={(e) => {
            e.preventDefault();
            MySwal.fire({
              text: `¿Desea eliminar el ítem normativo?`,
              icon: "question",
              confirmButtonText: "Aceptar",
              cancelButtonText: "Cancelar",
              showCloseButton: true,
              showCancelButton: true,
            }).then((result: SweetAlertResult) => {
              if (result.isConfirmed) {
                deleteItemNormativo(value.row.original.ID);
              }
            });
          }}></i>
      </div>
    );
  };

  const esAuditorParticipante = (users: string | undefined, emailUser: string) => {
    if (users !== undefined && users !== null) {
      let arrayUsers = users.split("; ");
      const result = arrayUsers.some((user) => user.trim() === emailUser);
      return result;
    }
    return false;
  };

  usePromiseEffect(async () => {
    let token = await userInfo;
    setToken(token);
    let currUser = await cognitoUserInfo();
    setCurrentUser(currUser);
    setIsLoading(is_test ?? true);

    let resultAuditoria: IAuditoria = is_test
      ? {}
      : (await getAPI(`${API_AUDITORIA}${API_AUDITORIA_GET_AUDITORIA}`, { Authorization: `Bearer ${token}` }, { ID: idAuditoria })).result;
    setAuditoriaSeleccionada(resultAuditoria);
    setValResponsableArea({
      mail: resultAuditoria.RESPONSABLE_AREA,
      name: resultAuditoria.RESPONSABLE_AREA_DISPLAY,
    });
    let mailsAuditoresParticipantes = resultAuditoria.AUDITORES_ACOMPANANTES.split("; ");
    let namesAuditoresParticipantes = resultAuditoria.AUDITORES_ACOMPANANTES_DISPLAY.split("; ");
    let arrayAuditoresParticipantes: IUserPickerValue[] = [];
    mailsAuditoresParticipantes.forEach((mailAuditor, index) => {
      if (mailAuditor !== "") {
        arrayAuditoresParticipantes.push({
          mail: mailAuditor,
          name: namesAuditoresParticipantes[index],
          image: "https://p16-tiktok-va-h2.ibyteimg.com/img/musically-maliva-obj/1624828413449221~c5_720x720.jpeg",
        });
      }
    });
    setValAuditoresParticipantes(arrayAuditoresParticipantes);

    if (!readonly) {
      if (
        (resultAuditoria.AUDITOR_LIDER === currUser.email || esAuditorParticipante(resultAuditoria.AUDITORES_ACOMPANANTES, currUser.email)) &&
        resultAuditoria.ID_ESTADO < EnumEstadoAuditoria.PlanListo
      ) {
        setIsEdit(true);
      } else {
        setIsEdit(false);
      }
    }

    let resultTipoAlcanceAuditoria = is_test
      ? { data: [] }
      : (
          await getAPI(
            `${API_AUDITORIA}${API_AUDITORIA_GET_TIPOALCANCE_AUDITORIA}`,
            { Authorization: `Bearer ${token}` },
            { ID: idAuditoria, ACTIVO: true }
          )
        ).result;
    setTipoAlcanceAuditoria(resultTipoAlcanceAuditoria.data);

    let paramsActive = {
      PAGINA: 1,
      PAGINADO: ROW_COUNT_MAX,
      ORDENADOPOR: `ID`,
      ORIENTACION: "DESC",
      ACTIVO: true,
    };

    let resultAllTipoAlcance = is_test
      ? { data: [] }
      : (await getAPI(`${URL_SUPPORT}${API_ADMIN_TIPO_ALCANCE}/getall`, { Authorization: `Bearer ${token}` }, paramsActive)).result;
    setAllTipoAlcanceAuditoria(resultAllTipoAlcance.data);

    paramsActive.ORDENADOPOR = `INO."ID"`;
    let resultItemNormativaAuditoria = is_test
      ? { data: [], pages: 10 }
      : (
          await getAPI(
            `${API_AUDITORIA}${API_AUDITORIA_GET_ITEMNORMATIVA_AUDITORIA}`,
            { Authorization: `Bearer ${token}` },
            { ...paramsActive, PAGINADO: ROW_COUNT, ID_AUDITORIA: idAuditoria }
          )
        ).result;
    setItemNormativaAuditoria(resultItemNormativaAuditoria.data);
    setPages(resultItemNormativaAuditoria.pages);

    let resultAllUnidadAuditar = is_test
      ? { data: [] }
      : (
          await getAPI(
            `${URL_SUPPORT}${API_ADMIN_TIPO_UNIDAD_AUDITAR}/getallFiltrado`,
            { Authorization: `Bearer ${token}` },
            {
              ...paramsActive,
              ID_TIPO_AUDITORIA: resultAuditoria.ID_TIPO_AUDITORIA,
              ORDENADOPOR: "ID",
              ACTIVO: true,
            }
          )
        ).result;
    setListUnidadesAuditar(resultAllUnidadAuditar.data);

    setIsLoading(false);
  }, []);

  const filter = async (filters: Partial<IItemNormativo>, page: boolean = false, size = pageSize) => {
    if (!filters) {
      filters = {};
    }
    filters.PAGINADO = size;
    if (filters.PAGINA === undefined) {
      filters.PAGINA = 1;
    }
    if (!page) {
      filters.PAGINA = 1;
    }
    setPage(filters.PAGINA);

    if (filters.ORDENADOPOR === undefined) {
      filters.ORDENADOPOR = "ID";
      filters.ORIENTACION = "DESC";
    }

    let result = is_test
      ? { data: [], pages: 10 }
      : (
          await getAPI(
            `${API_AUDITORIA}${API_AUDITORIA_GET_ITEMNORMATIVA_AUDITORIA}`,
            { Authorization: `Bearer ${token}` },
            { ...filters, ID_AUDITORIA: idAuditoria }
          )
        ).result;
    setItemNormativaAuditoria(result.data);
    let pages = result.pages;
    setPages(pages);
  };

  const columnHelperMantIncCausa = createColumnHelper<IItemNormativaxAuditoria>();
  let columnsDef = [
    columnHelperMantIncCausa.accessor((row) => row.ITEM_NORMATIVO, {
      id: "ITEM_NORMATIVO",
      cell: (info: CellContext<IItemNormativo, string>) => componentValue(info.getValue()),
      header: () => component("Item Normativo"),
      tipo: ITipo_Campo.label,
      title: "Item Normativo",
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.PREDIO_RECINTO, {
      id: "PREDIO_RECINTO",
      cell: (info: CellContext<IItemNormativo, string>) => componentValue(info.getValue()),
      header: () => component("Predio/Recinto"),
      tipo: ITipo_Campo.multiline,
      title: "Predio/Recinto<",
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.FECHA, {
      id: "FECHA",
      cell: (info: CellContext<IItemNormativo, string>) => componentValue(shortDate(info.getValue())),
      header: () => component("Fecha"),
      tipo: ITipo_Campo.date,
      title: "Fecha",
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.HORA_INICIO, {
      id: "HORA_INICIO",
      cell: (info: CellContext<IItemNormativo, string>) => componentValue(info.getValue()),
      header: () => component("Hora Inicio"),
      tipo: ITipo_Campo.text,
      title: "Hora Inicio",
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.HORA_FINAL, {
      id: "HORA_FINAL",
      cell: (info: CellContext<IItemNormativo, string>) => componentValue(info.getValue()),
      header: () => component("Hora Final"),
      tipo: ITipo_Campo.text,
      title: "Hora Final",
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.OBSERVACIONES, {
      id: "Observaciones",
      cell: (info: CellContext<IItemNormativo, string>) => componentValue(info.getValue()),
      header: () => component("Observaciones"),
      tipo: ITipo_Campo.multiline,
      title: "Observaciones",
    } as any),

    columnHelperMantIncCausa.accessor((row) => row.ID, {
      id: "OPCIONES",
      cell: (info: CellContext<IItemNormativo, string>) => componentOpciones(info),
      header: () => component("Opciones"),
      tipo: ITipo_Campo.text,
      disableSorting: true,
      hide: !isEdit,
    } as any),
  ] as any;

  const deleteItemNormativo = async (idItemNormativo: number) => {
    const url = `${API_AUDITORIA}${API_AUDITORIA_DELETE_ITEMNORMATIVO}`;
    await deleteAPI(
      url,
      { Authorization: `Bearer ${token}` },
      {
        ID: idItemNormativo,
        ID_AUDITORIA: idAuditoria,
      }
    );
    setIsLoading(true);
    await filter({});
    setIsLoading(false);
  };

  const formValidation = (value: Partial<IAuditoria>): boolean => {
    let arrErrors: Array<string> = [];

    if (!value.RESPONSABLE_AREA) {
      arrErrors.push("RESPONSABLE_AREA");
    }
    if (!value.TIPO_ALCANCE?.length) {
      arrErrors.push("ALCANCE");
      MySwal.fire({
        html: (
          <div>
            <h3>Debe seleccionar al menos un Alcance</h3>
          </div>
        ),
        text: "",
        icon: "error",
        showCloseButton: true,
      });
    }

    setArrErrorEmpty(arrErrors);
    return arrErrors.length === 0;
  };

  const getRequisitos = (item: any) => {
    let value: number[] = [];

    item.forEach((a: any) => {
      a.REQUISITOS_NORMATIVOS.forEach((r: any) => {
        value.push(r);
      });
    });

    return value;
  };

  const saveData = async (continuar?: boolean): Promise<any> => {
    let mailsAuditoresParticipantes = "";
    let namesAuditoresParticipantes = "";
    valAuditoresParticipantes?.forEach((auditor) => {
      mailsAuditoresParticipantes += auditor.mail + "; ";
      namesAuditoresParticipantes += auditor.name + "; ";
    });
    const value: Partial<IAuditoria> = {
      ...auditoriaSeleccionada,
      RESPONSABLE_AREA: valResponsableArea?.mail,
      RESPONSABLE_AREA_DISPLAY: valResponsableArea?.name,
      EDITOR: currentUser?.email,
      EDITOR_DISPLAY: currentUser?.fullname,
      FECHA_MODIFICACION: new Date(),
      AUDITORES_ACOMPANANTES_DISPLAY: namesAuditoresParticipantes.slice(0, -2),
      AUDITORES_ACOMPANANTES: mailsAuditoresParticipantes.slice(0, -2),
      ID_ESTADO: continuar ? EnumEstadoAuditoria.PlanListo : auditoriaSeleccionada?.ID_ESTADO,
      TIPO_ALCANCE: Array.from(document.getElementsByName("chkAlcance"))
        .filter((rn) => (rn as HTMLInputElement).checked)
        .map((rn) => parseInt((rn as HTMLInputElement).value)),
    };
    let f = false;
    if (formValidation(value)) {
      let result = (await postAPI(`${API_AUDITORIA}${API_AUDITORIA_POST_AUDITORIA}`, value, { Authorization: `Bearer ${token}` })).result;
      if (result) {
        f = true;
      }
    }
    return f;
  };
  return (
    <div className="row">
      <button
        data-testid="btnedit"
        hidden={true}
        onClick={() => {
          formValidation({});
          saveData(true);
          saveData(false);
          getRequisitos([{ REQUISITOS_NORMATIVOS: [1] }]);
          deleteItemNormativo(1);
        }}></button>
      {isLoading ? (
        <Loading />
      ) : (
        <div className="col-12">
          <div className="rounded bg-white p-2 shadow">
            <div className="container-fluid mb-4">
              <h1 className="titPrincipal colorTit">Auditoría</h1>

              <div className="card bg-light border p-3 pt-2 mt-2">
                <div className="row ajusteInput">
                  <div className="col-12">
                    <h6>
                      <span className="textSeccion">Auditoría</span>
                    </h6>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-6">
                    <label>Código de Auditoría</label>
                    <p className="mb-2">{auditoriaSeleccionada?.CORRELATIVO}</p>
                    <label>Tipo Auditoría</label>
                    <p className="mb-2">{auditoriaSeleccionada?.TIPO_AUDITORIA}</p>
                    <label>Estado Auditoría</label>
                    <p className="mb-2">{auditoriaSeleccionada?.ESTADO}</p>
                    <label>Ámbito de Auditoría</label>
                    <div className="mb-2">
                      {listUnidadesAuditar.map((ua) => {
                        return (
                          <div key={ua.ID} className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              value="option2"
                              disabled
                              defaultChecked={auditoriaSeleccionada?.UNIDAD_A_AUDITAR?.includes(ua.ID as number)}
                            />
                            <label className="form-check-label">{ua.NOMBRE}</label>
                          </div>
                        );
                      })}
                    </div>
                    <label>Objetivo, Alcance y Exclusiones</label>
                    <p className="mb-2">{auditoriaSeleccionada?.OBJETIVO_ALCANCE_EXCLUSIONES}</p>
                    <div className="row">
                      <div className="col-4">
                        <label>Fecha Desde</label>
                        <p className="mb-2">{shortDate(auditoriaSeleccionada?.FECHA_DESDE)}</p>
                      </div>
                      <div className="col-8">
                        <label>Fecha Hasta</label>
                        <p className="mb-2">{shortDate(auditoriaSeleccionada?.FECHA_HASTA)}</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-6">
                    <label>Cuenta con Auditor Externo</label>
                    <p className="mb-2">{auditoriaSeleccionada?.AUDITOR_EXTERNO ? "Sí" : "No"}</p>
                    <label>Vicepresidencia</label>
                    <p className="mb-2">{auditoriaSeleccionada?.VICEPRESIDENCIA}</p>
                    <label>Gerencia/Subgerencia</label>
                    <p className="mb-2">{auditoriaSeleccionada?.GERENCIA_SUBGERENCIA}</p>
                    <label>Unidad/Proyecto</label>
                    <p className="mb-2">{auditoriaSeleccionada?.UNIDAD_PROYECTO}</p>

                    <label>Responsable del área a Auditar</label>
                    <p className="mb-2">{auditoriaSeleccionada?.RESPONSABLE_AREA_DISPLAY}</p>
                    <label>Auditor Líder</label>
                    <p className="mb-2">{auditoriaSeleccionada?.AUDITOR_LIDER_DISPLAY}</p>
                    <label>Auditores Participantes</label>
                    <p className="mb-2">{auditoriaSeleccionada?.AUDITORES_ACOMPANANTES_DISPLAY}</p>
                  </div>
                </div>
              </div>

              <div className="card bg-light border p-3 pt-2 mt-2">
                <div className="row ajusteInput">
                  <div className="col-12">
                    <h6>
                      <span className="textSeccion">Plan Auditoría</span>
                    </h6>
                  </div>
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    {isEdit && <span className="text-danger">(*)</span>}
                    <label>Alcance</label>
                    <div className="mb-2">
                      {allTipoAlcanceAuditoria.map((tipoAlcance) => {
                        return (
                          <div key={tipoAlcance.ID} className={`${arrErrorEmpty.includes("ALCANCE") && "error"} form-check form-check-inline`}>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              value={tipoAlcance.ID}
                              defaultChecked={tipoAlcanceAuditoria.some((ta) => ta.ID === tipoAlcance.ID)}
                              disabled={!isEdit}
                              name={`chkAlcance`}
                              id={`chkAlcance${tipoAlcance.ID}`}
                            />
                            <label className="form-check-label" htmlFor={`chkAlcance${tipoAlcance.ID}`}>
                              {tipoAlcance.NOMBRE}
                            </label>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-6">
                    {isEdit && <span className="text-danger">(*)</span>}
                    <label>Responsable del área a Auditar</label>
                    {isEdit ? (
                      <UserPicker
                        name={"usrResponsableArea"}
                        callback={(id, value) => {}}
                        id={""}
                        multi={false}
                        disabled={false}
                        defaultValue={
                          auditoriaSeleccionada
                            ? {
                                name: auditoriaSeleccionada.RESPONSABLE_AREA_DISPLAY,
                                mail: auditoriaSeleccionada.RESPONSABLE_AREA,
                              }
                            : null
                        }
                        className={`${arrErrorEmpty.includes("RESPONSABLE_AREA") && "error"} responsableYauditores`}
                      />
                    ) : (
                      <p className="mb-2">{auditoriaSeleccionada?.RESPONSABLE_AREA_DISPLAY}</p>
                    )}
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-6">
                    <label>Auditores Participantes</label>

                    {isEdit ? (
                      <UserPicker
                        name={"usrResponsableArea"}
                        callback={(id, value) => {
                          if (value === undefined) {
                            return;
                          }
                          setValAuditoresParticipantes(value);
                        }}
                        id={""}
                        multi={true}
                        disabled={false}
                        defaultValue={valAuditoresParticipantes}
                        className={`${arrErrorEmpty.includes("AUDITOR_LIDER") && "error"} responsableYauditores`}
                      />
                    ) : (
                      <p className="mb-2">{auditoriaSeleccionada?.AUDITORES_ACOMPANANTES_DISPLAY}</p>
                    )}
                  </div>
                </div>
              </div>

              {isOpenModalItemNormativo && (
                <FormItemNormativa
                  isOpen={isOpenModalItemNormativo}
                  idAuditoria={idAuditoria}
                  createdItemNormativo={selectedItemNormativoList}
                  callBack={() => {
                    filter({});
                    setIsOpenModalItemNormativo(false);
                    setSelectedItemNormativo(null);
                    setSelectedItemNormativoList(null);
                  }}
                  callBackClose={() => {
                    setIsOpenModalItemNormativo(false);
                    setSelectedItemNormativo(null);
                    setSelectedItemNormativoList(null);
                  }}
                  selectedItemNormativo={selectedItemNormativo || null}
                />
              )}
              {auditoriaSeleccionada && auditoriaSeleccionada.ID_ESTADO < EnumEstadoAuditoria.PlanListo && (
                <div id="collapseGeneradas">
                  <div className="card card-body border-0 p-0 mt-2">
                    <div className="row">
                      <div className="col-12">
                        <div className="rounded bg-white p-2 shadow">
                          <div className="container-fluid mb-4">
                            <h1 className="titPrincipal colorTit mt-2"></h1>

                            {readonly || !isEdit || (
                              <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12 pt-0">
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-primary float-end"
                                    onClick={async () => {
                                      let f = await saveData();
                                      if (f) {
                                        setIsOpenModalItemNormativo(true);
                                        setSelectedItemNormativo(null);
                                        setSelectedItemNormativoList({ REQUISITOS_NORMATIVOS: getRequisitos(itemNormativaAuditoria) as any });
                                      }
                                    }}>
                                    <i className="bi bi-plus-circle me-2"></i> Agregar Ítem Normativo
                                  </button>
                                </div>
                              </div>
                            )}
                            <div className="row">
                              <div className="col-12">
                                {(esVistaPlan || !readonly) && (
                                  <AdminLista
                                    hideAdd={true}
                                    hideExport={true}
                                    data={itemNormativaAuditoria || []}
                                    callback={() => {}}
                                    reload={filter}
                                    filter={filter}
                                    pagination={{
                                      pages: pages,
                                      page: page,
                                      paging: filter,
                                    }}
                                    tipo="Programaciones"
                                    columnsDef={columnsDef}
                                    callbackUpdatePageSize={(pageSize: number, filters: Object) => {
                                      setPageSize(pageSize);
                                      filter(filters, false, pageSize);
                                    }}
                                  />
                                )}
                              </div>
                              <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12 mt-3">
                                  {isSendingData ? (
                                    <Loading />
                                  ) : (
                                    <div>
                                      {isEdit && (
                                        <span>
                                          <button
                                            type="button"
                                            className="btn btn-sm btn-primary me-2"
                                            onClick={async () => {
                                              setIsSendingData(true);
                                              await saveData();
                                              setIsSendingData(false);
                                            }}
                                            disabled={isSendingData}>
                                            Grabar
                                          </button>

                                          <button
                                            type="button"
                                            className="btn btn-sm btn-outline-primary me-2"
                                            onClick={async () => {
                                              setIsSendingData(true);
                                              let mailsAuditoresParticipantes = "";
                                              let namesAuditoresParticipantes = "";
                                              valAuditoresParticipantes?.forEach((auditor) => {
                                                mailsAuditoresParticipantes += auditor.mail + "; ";
                                                namesAuditoresParticipantes += auditor.name + "; ";
                                              });
                                              await postAPI(
                                                `${API_AUDITORIA}${API_AUDITORIA_POST_AUDITORIA_APROBARAUDITORIA}`,
                                                {
                                                  ID: idAuditoria,
                                                  EDITOR: currentUser?.email,
                                                  EDITOR_DISPLAY: currentUser?.fullname,
                                                  FECHA_MODIFICACION: new Date(),
                                                  ENVIAR_NOTIFICACION: true,
                                                  RESPONSABLE_AREA: valResponsableArea?.mail,
                                                  RESPONSABLE_AREA_DISPLAY: valResponsableArea?.name,
                                                  AUDITORES_ACOMPANANTES_DISPLAY: namesAuditoresParticipantes.slice(0, -2),
                                                  AUDITORES_ACOMPANANTES: mailsAuditoresParticipantes.slice(0, -2),
                                                },
                                                { Authorization: `Bearer ${token}` }
                                              );
                                              AuditoriaService.GenerarPDFPlan(token, idAuditoria);
                                              setTimeout(() => {
                                                window.location.href = "/auditoria/home";
                                              }, 2000);
                                            }}
                                            disabled={isSendingData}>
                                            Continuar
                                          </button>
                                        </span>
                                      )}

                                      {!readonly && (
                                        <button
                                          type="button"
                                          data-testid="testbtnagregar"
                                          className="btn btn-sm btn-primary"
                                          onClick={() => (window.location.href = "/auditoria/home")}
                                          disabled={isSendingData}>
                                          <i className="bi bi-arrow-left-circle me-2"></i> Volver
                                        </button>
                                      )}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
